export default __webpack_public_path__ + "static/media/Group 2978.4375c12a.png";